import {SEARCH_REQUEST_SET_TERM} from '../search-request/search-request-actions';
import {FILTERS_RESET, FILTERS_UPDATE} from './filters-actions';
import {initialReservationTypes} from './filters-utils';

export const initialState = {
    numActive: 0,
    amenities: {},
    activeAmenities: [],
    reservationTypes: {...initialReservationTypes},
    activeReservationType: 'all',
    viaQuickFilter: false,
};

export default function filters(state = initialState, {type, payload}) {
    switch (type) {
        case FILTERS_RESET:
        case SEARCH_REQUEST_SET_TERM: {
            return initialState;
        }

        case FILTERS_UPDATE: {
            const newState = {
                ...state,
                ...payload,
            };

            newState.numActive = newState.activeAmenities.length;

            return newState;
        }

        default:
            return state;
    }
}
